module.exports = __webpack_public_path__ + "./fonts/main-regular.ttf";